export const cardTitleStyle = theme => ({
  container: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  },

  icon: {
    fontSize: '18px',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(),
    color: theme.variables.colors.icon,
  },

  iconMarginNone: {
    '& $icon': {
      marginLeft: '0',
    },
  },

  title: {
    fontSize: '20px',
    color: theme.palette.text.primary,
    margin: 0,
    fontWeight: 300,
    textTransform: 'initial',
    letterSpacing: 'initial',
  },
})
